import React from 'react';

import LocationTeaser from './Teaser';
import LocationDetail from './Detail';

const NodeLocation = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <LocationTeaser {...props} />;
  }

  return <LocationDetail {...props} />;
};

export default NodeLocation;
